import { Sheet } from 'react-modal-sheet';
import styles from './style.module.scss';
import CloseIcon from 'assets/icons/close-icon.svg?react';
import { forwardRef } from 'react';

export type UIModalProps = {
  visible: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  snapPoints?: number[];
  detent?: 'full-height' | 'content-height';
  zIndex?: number;
};

export const UIModal = forwardRef<HTMLDivElement, UIModalProps>(
  ({ visible, onClose, children, detent, snapPoints, zIndex }, ref) => {
    const handleBackdropClick = () => {
      // Add a small delay to ensure click doesn't propagate
      setTimeout(() => {
        onClose();
      }, 0);
    };

    const sheetStyle = zIndex ? { zIndex } : undefined;

    return (
      <>
        <Sheet
          isOpen={visible}
          onClose={onClose}
          className={styles.root}
          snapPoints={snapPoints}
          detent={detent}
          disableDrag={false}
          style={sheetStyle}
        >
          <Sheet.Container className={`${styles.container} my-border`} ref={ref}>
            <Sheet.Scroller>
              <Sheet.Header className={styles.header}>
                <div className={styles.closeBtn} onClick={onClose}>
                  <CloseIcon />
                </div>
              </Sheet.Header>

              <Sheet.Content className={styles.content}>{children}</Sheet.Content>
            </Sheet.Scroller>
          </Sheet.Container>
          <Sheet.Backdrop onTap={handleBackdropClick} />
        </Sheet>
      </>
    );
  },
);
